import { ServiceHistoryService } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

type ProofUploadParams = {
  serviceHistoryId: number;
  userId: number;
  file: Blob;
};

export const useServiceHistoryProofUploadMutation = () =>
  useMutation(
    (input: ProofUploadParams) =>
      ServiceHistoryService.postServiceHistoryProofOfService(input.serviceHistoryId, input.userId, {
        file: input.file
      }),
    {
      onSuccess: () => {
        toast.success('Successfully uploaded file!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
      }
    }
  );
